import { render, staticRenderFns } from "./CurrentProjectGraphv2.vue?vue&type=template&id=51c57ca4&scoped=true&"
import script from "./CurrentProjectGraphv2.vue?vue&type=script&lang=js&"
export * from "./CurrentProjectGraphv2.vue?vue&type=script&lang=js&"
import style0 from "./CurrentProjectGraphv2.vue?vue&type=style&index=0&id=51c57ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c57ca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
